import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('riseAiCredit'),
  titleToId: true,
  titleToNamespace: true,
  avatarPath: avatars.riseAi,
  logoPath: logos.riseAi,
  hasConnectionStatus: false
});
